export const surchargeRate = 3;
export const surchargeRateStr = '3%';

export const calculateSurcharge = (amount, fee = surchargeRate) => {
  return amount * (fee / 100);
};
